export var mutations = {
    setJob: function (s, job) { return s.job = job; },
    setAttachedAttributes: function (s, attributes) { return s.job.attributes = attributes; },
    setReferrerName: function (s, url) { return s.referrerName = url || 'Jobs.Index'; },
    setStartTime: function (s, time) { return s.startTime = time; },
    setAssignees: function (s, assignees) { return s.assignees = assignees; },
};
